export const GOSCRIPT_TEMPLATES = [
    {
        name: 'blank',
        type: 'auth',
        icon: 'fa-file',
        title: 'Blank',
        description: 'Start with an empty template to manually configure your script from scratch.',
        template: '',
    },
    {
        name: 'auth',
        type: 'auth',
        icon: 'fa-code',
        title: 'Authentication Script',
        description:
            'Automates login processes to ensure scanner authentication and session maintenance.',
        template: `\
# This is an example GoScript further examples and documentation can be found
# at https://support.appcheck-ng.com/hc/en-us/articles/8841915523485-Authentication-GoScripts

def auth.login
    # Go to the login page and wait for it to load
    go: https://www.example.com/
    wait for: Forgot password?

    # Submit our credentials and wait for the next page to load
    username = {username}
    password = {password}
    click: Login
    wait for: My Account

    click: My Account
    wait for: Change address
    # If "Change address" does not appear on the page then the login has failed

def auth.confirm
    go: https://www.example.com
    wait for: My Account

    click: My Account
    wait for: Change address
    # If "Change address" does not appear on the page then we have failed to confirm
    # that we are still logged in, so the scanner will run auth.login again

def auth.logout
    click: menu
    wait for: logout
    # We do not need a "go:" command here because the menu button on this
    # site is always visible, whatever page the browser is on.    Instead we
    # just click the menu button then wait for the logout button to appear.

    click: logout
    wait for: Forgot password?
    # When we see the login page again we know we've successfully logged out.
  `,
    },
    {
        name: 'workflow',
        type: 'workflow',
        icon: 'fa-code',
        title: 'Workflow Script',
        description:
            'Simulates specific application workflows, guiding the scanner through various user interactions to thoroughly test different parts of your application.',
        template: `# This is an example of a Workflow GoScript to guide the scanner through specific user journeys within the application,
# ensuring all critical areas are tested by simulating user interactions that automated crawling might miss.
# For more details, refer to the documentation: https://support.appcheck-ng.com/hc/en-us/articles/14270295419677-Direct-the-Scanner-Through-a-Particular-Application-Journey-Using-a-WorkFlow-GoScript

def seeding.workflow1:
    go: https://www.example.com
    wait for: Home
    click: Home

def seeding.workflow2:
    go: https://www.example.com
    wait for: Home
    hover: Services
    click: Features
    wait for: OUR SOFTWARE

def seeding.general:
    # The 'seeding.general' function is required and is executed to seed the crawler with targets.
    # Add a list of GoScript commands you wish to execute to ensure that the scanner can follow all specified paths within the application.

    # Calls all the individual workflow functions.
    seeding.workflow1
    seeding.workflow2
`,
    },
];

export const getGoScriptTemplateByName = (name) => {
    const template = GOSCRIPT_TEMPLATES.find((item) => item.name === name);
    return template ? template.template : '';
};

export const ApckGoScriptTemplateModal = {
    props: {
        canUsePrivateHub: {
            type: Boolean,
            default: true
        },
    },
    data() {
        return {
            scripts: GOSCRIPT_TEMPLATES,
        };
    },
    computed: {
        enableGoscriptAI: function() {
            if (this.$permissions?.enable_goscript_ai) return true;
            return false;
        },
    },
    methods: {
        clickScript(item) {
            this.$emit('load', item.template, item.type);
            this.$emit('close');
        },
        clickWizard() {
            this.$emit('wizard');
            this.$emit('close');
        },
        clickGenerate() {
            this.$emit('generate');
            this.$emit('close');
        },

    },
    template: `
        <div class="goscript-tpl">
        <div class="goscript-tpl__container">
            <div v-if="enableGoscriptAI" :class="{'goscript-tpl__item': true, 'goscript-tpl__item--muted': !canUsePrivateHub}"  v-on:click="clickGenerate">
                <i class="fa-solid fa-hat-wizard goscript-tpl__icon"></i>
                <div class="goscript-tpl__content">
                    <div v-if="!canUsePrivateHub" class="goscript-tpl__title">Generate with AI (only available on public hubs)</div>
                    <div v-else class="goscript-tpl__title">Generate with AI (recommended)</div>
                    <div class="goscript-tpl__description">Use an AI-powered assistant to help create your script.</div>
                </div>
            </div>
            <div class="goscript-tpl__item"  v-on:click="clickWizard">
                <i class="fa-solid fa-wand-magic-sparkles goscript-tpl__icon"></i>
                <div class="goscript-tpl__content">
                    <div class="goscript-tpl__title">Wizard</div>
                    <div class="goscript-tpl__description">Use a step-by-step guided wizard to help create your script.</div>
                </div>
            </div>
            <div v-for="(item, index) in scripts" :key="index" class="goscript-tpl__item" @click="clickScript(item)">
                <i :class="['fa-solid', item.icon, 'goscript-tpl__icon']"></i>
                <div class="goscript-tpl__content">
                <div class="goscript-tpl__title">{{ item.title }}</div>
                <div class="goscript-tpl__description">{{ item.description }}</div>
                </div>
            </div>
            </div>
        </div>
    `,
};
